import Axios from "axios";
import Configuration from "./Configuration";
import store from "../src/store";
import router from "../src/router";

export class UserClass {

  constructor() {
    this.token = Configuration.read("token") || null;
    this.id = Configuration.read("id") || null;
    this.username = null;
    this.email = null;
    this.firstName = null;
    this.lastName = null;
    this.role = null;
    this.lease = null;
    this.notSignedOnCurrentLease = false;

    if (this.token) {
      this._loadProfile();
    }
  }

  /**
   * @param {string} username
   * @param {string} password
   */
  async login(username, password) {
    let result = await Axios.post(CONFIG.urlServer + "/api/login_check", {
      username,
      password
    });

    if (CONFIG.organization && result.data.organization !== CONFIG.organization) {
      throw "invalid_organization";
    }
    if (CONFIG.property && result.data.property !== CONFIG.property) {
      throw "invalid_property";
    }

    this.token = result.data.token;
    store.state.organization = result.data.organization;
    store.state.property = result.data.property;
    Configuration.write("token", this.token);
    Configuration.write("organization", result.data.organization);
    Configuration.write("property", result.data.property);
    this.username = username;
    await this._loadProfile();
    return result;
  }

  logout() {
    this.token = null;
    Configuration.delete("token");
    Configuration.delete("id");
  }

  /**
   * @param {string} email
   * @param {string} locale
   * @param {string} branding
   */
  async resetPassword(email, locale, branding) {
    let result = await Axios.post(CONFIG.urlServer + "/api/forgot_password/", {
      email,
      locale: locale,
      redirect_url: CONFIG.urlProduction + "/#/reset_password?token={TOKEN}",
      branding: branding
    }).catch(_ => {
      return null;
    });
    return result;
  }

  async save() {
    let result = await Axios.put(CONFIG.urlServer + "/api/users/" + this.id, {
      email: this.email
    }, {
      headers: {
        "Authorization": "Bearer " + this.token
      }
    }).catch(_ => {
      return null;
    });
    return result;
  }

  async saveDeviceToken(token) {
    try {
      let result = await Axios.put(CONFIG.urlServer + "/api/me", {
        deviceToken: token
      }, {
        headers: {
          "Authorization": "Bearer " + this.token
        }
      });
      return result;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  async resetWithToken(token, password) {
    try {
      let result = await Axios.post(CONFIG.urlServer + "/api/forgot_password/" + token, {
        password: password
      });
      return result;
    } catch (e) {
      return null;
    }
  }

  /**
   * @private
   */
  async _loadProfile() {
    await Axios.get(CONFIG.urlServer + "/api/me", {
      headers: {
        "Authorization": "Bearer " + this.token
      }
    })
      .then(result => {
      this.id = result.data.id;
      Configuration.write("id", result.data.id);
      this.firstName = result.data.firstName;
      this.lastName = result.data.lastName;
      this.email = result.data.email;
      this.role = result.data.role;
      this.lease = result.data.lease;
      this.notSignedOnCurrentLease = result.data.notSignedOnCurrentLease;
      })
      .catch( err => {
        this.logout();
        router.push("/login")
      });
  }

}

let User = new UserClass();
export default User;